<p>project-publish works!</p>
